<template>
  <div class="medtronic-doctor-payments graphic-container" :class="{ 'graphic-container--social-mode': this.socialMode }">
    <h3 class="chart-hed" v-if="showHeading">Medtronic has paid hundreds of millions to doctors and hospitals in the US</h3>
    <p v-if="showDeck">In the last five years, more than $900 million has been paid for research, travel, royalties, consulting fees and more.</p>
    <column-chart :chart-height-ratio="baseHeightRatio" :chart-data="data" :chart-options="options"></column-chart>
    <p class="chart-source">Source: <a href="https://openpaymentsdata.cms.gov/">U.S. Centers for Medicare and Medicaid Services</a></p>
  </div>
</template>

<script>
  import data from '../assets/medtronic-doctor-payments.json'
  import ColumnChart from '@/components/ColumnChart.vue'
  import embeddable from '../mixins/embeddable'

  export default {
    name: 'MedtronicDoctorPayments',
    mixins: [embeddable],
    components: {
      ColumnChart,
    },
    data() {
      return {
        data,
        options: {
          chartName: "medtronic-doctor-payments",
          seriesName: "amount",
          labelWidth: 50,
          barColor: "#3B98AB",
          xAxisTickFormat: this.xAxisYearFormat,
          yAxisTickFormat: function(d) {return d === 0 ? d : "$" + d/1000000 + "m";},
          yAxisTicks: 5,
        }
      }
    }
  }
</script>
